import FieldProject from "../../../generic/entity/project/project";
import FieldConfig from "../../../../fields3/proto/field-config";
import FieldExpenseProject_FormElement from "./render/form-element";
import FieldExpenseProject_InlineEditable from "./render/inline-editable";
import {FieldFilterType} from "../../../proto/types";
import FieldExpenseProject_ConditionForm from "./render/condition"
import {ConditionType_Excludes, ConditionType_Includes} from "../../../../model2/conditions/condition-types";
import { EntityType } from "../../../../gd/const/item";

// we need it because list of available projects is differnt from all projects (!)

export default class FieldExpenseProject extends FieldProject {

    constructor(config:FieldConfig) {
        super(config);

        this.conditionTypes     = [ConditionType_Includes, ConditionType_Excludes]
        this.parentsFor         = EntityType.EXPENSE

        this.typeLabel      = "Project";

        this.filterType     = FieldFilterType.DROPDOWN_DYNAMIC

        this.renderComponents.formElement       = FieldExpenseProject_FormElement
        this.renderComponents.inlineEditable    = FieldExpenseProject_InlineEditable

        this.renderComponents.conditionForm     = FieldExpenseProject_ConditionForm
    }
}
